import { CmsCategoryCodeEnum, CmsDirectoryCodeEnum } from '~/src/models/enums/cms.enum';
import {
    getArticlesDictionary,
    getDirectoryRecordsDictionary,
    getSectionsDictionary,
} from '~/src/repositories/cms/shared/cms.base.repository';
import {
    getMappedAboutProductData,
    getMappedKnowledgeBaseData,
} from '~/src/repositories/cms/entities/knowledge-base/utils/cms.knowledge-base.utils';
import type { DictionaryArticleInterface } from '~/src/repositories/cms/types/cms.types';

export const getMtsKnowledgeBase = async (isSSR?: boolean) => {
    const productGroups = await getDirectoryRecordsDictionary({
        isSSR,
        directoryCode: CmsDirectoryCodeEnum.PRODUCT_GROUP_KNOWLEDGE_BASE,
    });

    const knowledgeBaseProductCards = await getSectionsDictionary({
        isSSR,
        categoryCode: CmsCategoryCodeEnum.KNOWLEDGE_BASE,
        showArticleContent: false,
    });

    const knowledgeBaseProductGroup = await getSectionsDictionary({
        isSSR,
        categoryCode: CmsCategoryCodeEnum.PRODUCT_GROUP_KNOWLEDGE_BASE,
        showArticleContent: false,
    });

    return getMappedKnowledgeBaseData(
        productGroups,
        knowledgeBaseProductGroup as DictionaryArticleInterface[],
        knowledgeBaseProductCards as DictionaryArticleInterface[],
    );
};

export const getMtsAboutProductBySefUrl = async (
    isSSR: boolean,
    categoryCode: CmsCategoryCodeEnum,
    articleSefUrl?: string,
) => {
    const data = await getArticlesDictionary({
        isSSR,
        categoryCode,
        articleSefUrl,
    });

    const knowledgeBaseProductCards = await getSectionsDictionary({
        isSSR,
        categoryCode: CmsCategoryCodeEnum.KNOWLEDGE_BASE,
        showArticleContent: false,
    });

    if ('cmsFailed' in data) {
        return { cmsFailed: true };
    }

    return getMappedAboutProductData(data, knowledgeBaseProductCards as DictionaryArticleInterface[]);
};
